 (function () {
      const toggle = document.getElementById("themeToggle");
      const root = document.documentElement;

      // Load saved theme (default is dark)
      const savedTheme = localStorage.getItem("theme");

      if (savedTheme) {
        root.setAttribute("data-theme", savedTheme);
      } else {
        root.setAttribute("data-theme", "dark");
      }

      toggle.addEventListener("click", () => {
        const currentTheme = root.getAttribute("data-theme");
        const newTheme = currentTheme === "dark" ? "light" : "dark";

        root.setAttribute("data-theme", newTheme);
        localStorage.setItem("theme", newTheme);
      });
    })();